<template>
  <v-container
    v-if="
      Object.entries(selectedSurvey).length != 0 ||
        filterSurveyResponses.length != 0
    "
  >
    <v-data-table
      :headers="responseHeaders"
      :items="filterSurveyResponses"
      :expanded.sync="expanded"
      show-expand
      item-key="pk"
      class="elevation-1"
      @click:row="expandRow"
    >
      <!-- Row Details In Data Table -->
      <template v-slot:item.survey_taker_id="{ item }">
        {{ getStakeholderName(item.survey_taker_id) }}
      </template>
      <template v-slot:item.timestamp="{ item }">
        {{ messageTimestamp(item.timestamp) }}
      </template>
      <!-- Expanding Card For Response Info -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card-text>
            <v-icon>label</v-icon>
            {{ getSurveyName() }}
          </v-card-text>
          <v-card-text>
            <v-icon>question_answer</v-icon>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(questionAnswer, questionName) in item.response_json"
                :key="questionName + questionAnswer"
              >
                <v-expansion-panel-header
                  v-if="!questionName.includes('-Comment')"
                >
                  {{ metaData[questionName] }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card
                    v-if="!questionName.includes('-Comment')"
                    flat
                  >
                    <!-- Answers with indexs for answers -->
                    <v-row
                      v-if="
                        metaData.questionsWithIndexForAnswer.includes(
                          questionName
                        )
                      "
                    >
                      <v-col>
                        <ul>
                          <li>
                            {{
                              metaData.dynamicOptions[questionName][
                                questionAnswer - 1
                              ]
                            }}
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                    <!-- Answers that are in arrays -->
                    <v-row
                      v-else-if="
                        metaData.questionsWithArrayForAnswer.includes(
                          questionName
                        )
                      "
                      dense
                    >
                      <v-col
                        v-for="answer in questionAnswer"
                        :key="answer"
                        sm="4"
                      >
                        <v-sheet>
                          <v-card-text
                            v-if="!['other', 'Other'].includes(answer)"
                            class="px-0"
                          >
                            <ul>
                              <li>
                                {{ answer }}
                              </li>
                            </ul>
                          </v-card-text>
                          <v-card-text v-else>
                            <ul>
                              <li>
                                Other:
                                {{
                                  item.response_json[questionName + "-Comment"]
                                }}
                              </li>
                            </ul>
                          </v-card-text>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <!-- Single Answer Responses (questionName: "string") -->
                    <v-row v-else>
                      <v-col>
                        <ul>
                          <li>
                            {{ questionAnswer }}
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <!-- Stakeholder Card Toggle Button -->
          <v-card-text>
            <v-icon>account_circle</v-icon>
            <v-btn
              text
              @click="
                setStakeholder(item.survey_taker_id);
                toggleStakeholderCard(true);
              "
            >
              {{ getStakeholderName(item.survey_taker_id) }}
            </v-btn>
          </v-card-text>
          <!-- Stakeholder Card Toggle Button End -->
        </td>
      </template>
    </v-data-table>
    <!-- Stakeholder Card -->
    <SurveyResponseStakeholderCard :current-stakeholder="currentStakeholder" />
    <!-- Stakeholder Card End -->
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import SurveyResponseStakeholderCard from "./SurveyResponseStakeholderCard";
import moment from "moment";
export default {
  name: "SurveyResponses",
  components: {
    SurveyResponseStakeholderCard
  },
  props: {
    metaData: { type: Object, default: () => {} }
  },
  data() {
    return {
      expanded: [],
      snackbar: false,
      currentStakeholder: {},
      responseHeaders: [
        {
          text: "Stakeholder",
          align: "left",
          value: "survey_taker_id"
        },
        {
          text: "Date & Time Completed",
          align: "left",
          value: "timestamp"
        }
      ]
    };
  },
  computed: {
    ...mapState("surveyResponseFiltering", [
      "filter",
      "surveys",
      "responses",
      "stakeholders",
      "selectedFilterOptions"
    ]),
    ...mapState({
      selectedSurvey: state => state.survey.selectedSurvey
    }),
    filterSurveyResponses() {
      if (Object.keys(this.selectedSurvey).length === 0) {
        return [];
      }
      let filteredResponses = this.responses.filter(
        response => response.survey === this.selectedSurvey.pk
      );
      if (this.filter) {
        let questions = Object.keys(this.selectedFilterOptions);
        let filteredOptions = Object.values(this.selectedFilterOptions);
        filteredResponses = filteredResponses.filter(response => {
          let arrayOfFlags = [];
          questions.forEach((question, index) => {
            if (filteredOptions[index].length !== 0) {
              let inListFlag;
              if (Array.isArray(response.response_json[question])) {
                inListFlag =
                  [
                    filteredOptions[index],
                    response.response_json[question]
                  ].reduce((a, b) => a.filter(c => b.includes(c))).length > 0;
                arrayOfFlags.push(inListFlag);
              } else {
                inListFlag = filteredOptions[index].includes(
                  response.response_json[question]
                );
                arrayOfFlags.push(inListFlag);
              }
            }
          });
          if (!arrayOfFlags.includes(false)) {
            return response;
          }
        });
      }
      this.updateFilteredResponsesBasedOnFilterOptions(filteredResponses);
      return filteredResponses;
    }
  },
  methods: {
    ...mapActions("surveyResponseFiltering", [
      "toggleStakeholderCard",
      "updateFilteredResponsesBasedOnFilterOptions"
    ]),
    expandRow(value) {
      this.expanded = value === this.expanded[0] ? [] : [value];
    },
    setStakeholder(pk) {
      this.currentStakeholder = this.stakeholders.find(
        stakeholder => stakeholder.pk === pk
      );
    },
    messageTimestamp(timestamp) {
      let format = "MMMM Do YYYY, h:mm a";
      return moment(timestamp)
        .local()
        .format(format);
    },
    getSurveyName() {
      if (Object.keys(this.selectedSurvey).length === 0) {
        return "";
      }
      return this.selectedSurvey.name;
    },
    getStakeholderName(pk) {
      return this.stakeholders.find(stakeholder => stakeholder.pk === pk)
        .get_full_name;
    }
  }
};
</script>
<style scoped></style>
